import { useState } from 'react';
import { Tooltip, Image } from "antd";
import { UndoOutlined } from '@ant-design/icons';
import 'react-photo-view/dist/react-photo-view.css';
import { PhotoProvider, PhotoView as PhotoViewWrap, PhotoSlider } from 'react-photo-view';

interface TextPriviewImagePropsType {
  text: string;
  previewList?: string[];
  imageUrl: (url: string) => string
}

function TextPriviewImage(props: TextPriviewImagePropsType) {
  const { text, previewList, imageUrl } = props;
  const [visible, setVisible] = useState(false);

  const [photoIndex, setPhotoIndex] = useState(0);
  return (
    <>
      <Tooltip placement="topLeft" title={text} arrowPointAtCenter>
        <p className="ellipsis click-span" onClick={() => { setVisible(true) }}>{text}</p>
      </Tooltip>
      {previewList ? (
        <div style={{ display: 'none' }}>
      <PhotoProvider>
        <PhotoSlider
          toolbarRender={
            ({ rotate, onRotate, overlay }) => {
              return <UndoOutlined onClick={() => { onRotate(rotate + 90) }} />;
            }}
          images={previewList.map((item,index) => ({ src: imageUrl(item),key:index }))}
          bannerVisible={true}
          visible={visible}
          onClose={() => setVisible(false)}
          index={photoIndex}
          onIndexChange={setPhotoIndex}
        />
      </PhotoProvider>
      </div>
      ) : ''}
    </>
  );
}

export default TextPriviewImage;